module.exports = __webpack_public_path__ + "img/2.dd53609d.jpg";